import * as React from 'react';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import { transitionSlideFromBottom } from '../../theme/transition';
import overlayStyles from '../../styles/scrollable-overlay';
import { SVGIcon } from '../svg-icon';

export interface ScrollableOverlayProps {
  show: boolean;
  onRequestClose(): void;
}

export class ScrollableOverlay extends React.Component<ScrollableOverlayProps, never> {
  static styles = overlayStyles;

  render() {
    const { show, children, onRequestClose } = this.props;

    return (
      <ReactCSSTransitionGroup {...transitionSlideFromBottom()}>
        {show && (
          <div className={overlayStyles.container}>
            <section className={overlayStyles.wrapper}>
              <button onClick={onRequestClose} className={overlayStyles.closeButton}>
                <SVGIcon.Cross size={10} color="black" />
              </button>
              {children}
            </section>
          </div>
        )}
      </ReactCSSTransitionGroup>
    );
  }

  componentWillReceiveProps(nextProps: ScrollableOverlayProps) {
    document.body.style.overflow = nextProps.show ? 'hidden' : 'initial';
  }
}
